// ============================================================================
// FSA PRINT SERVICE
// ============================================================================
// Client wrapper for the unified FS print engine. Single-note preview
// today; full FS bundle (statements + reports + signatories) when FSA-3
// lights up the custom endpoint.

import { get, post } from '../../client/axiosClient';
import { fsaPrintEndpoints } from '../../endpoints/fsa/fsaPrint.endpoints';
import type { ID } from '../../types';
import type { FsAmountMode, FsPrintSpec } from '../../types/fsa/print.types';

class FsaPrintService {
  /**
   * Server-rendered single-note PDF blob. Returns the raw Blob so the
   * preview modal can render it inside an iframe via URL.createObjectURL —
   * same pattern as the template preview / CRS booking confirmation.
   */
  async getSingleNotePdfBlob(
    engagementId: ID,
    scheduleId: ID,
    mode: FsAmountMode,
  ): Promise<Blob> {
    const response = await get<Blob>(
      fsaPrintEndpoints.singleNotePdf(engagementId, scheduleId, mode),
      { responseType: 'blob' },
    );
    return response.data;
  }

  /**
   * FSA-3 — custom print spec. Posts the full FsPrintSpec body and
   * receives a PDF blob.
   */
  async getCustomPdfBlob(spec: FsPrintSpec): Promise<Blob> {
    const response = await post<Blob>(fsaPrintEndpoints.custom(), spec, {
      responseType: 'blob',
    });
    return response.data;
  }
}

export const fsaPrintService = new FsaPrintService();
export default fsaPrintService;
